import {
    getMe,
    setAuthToken,
    setNewToken,
    setRefreshTokenInterceptor,
} from 'api';
import { deleteCookie, getCookie } from 'cookies-next';
import {
    authSuccess,
    handleAuthorization,
    logout,
    setAuthDetails,
} from 'store/auth';
import { handleResetData } from 'store/company';
import { fetchCurrentUserProfile } from 'store/currentUser';
import {
    AUTH_TOKEN_COOKIE,
    REFRESH_TOKEN_COOKIE,
} from '../data/globalConstants';
import { options } from './cookie';
import parseJwt from './parse-jwt';

export default async function auth(store, req, res, params = null) {
    const refreshToken = getCookie(REFRESH_TOKEN_COOKIE, { req, res });
    setRefreshTokenInterceptor(store.dispatch, req, res);

    if (!refreshToken) {
        return;
    }

    const token = getCookie(AUTH_TOKEN_COOKIE, { req, res });
    if (token) {
        setAuthToken(token);
    } else {
        try {
            await setNewToken(store.dispatch, req, res, refreshToken);
        } catch {
            clearSession(store, req, res);
            return;
        }
    }

    const updatedRefreshToken = getCookie(REFRESH_TOKEN_COOKIE, { req, res });
    const { exp } = parseJwt(updatedRefreshToken);
    const currDate = new Date();
    const isTokenExpired = new Date(exp * 1000) < currDate;

    if (isTokenExpired) {
        clearSession(store, req, res);
        return;
    }

    // Unguarded, a session the API will not renew took the whole render down
    // with it: getServerSideProps rejected and the page answered 500 instead of
    // sending the user somewhere they can sign in again.
    let me;
    try {
        me = (await getMe()).data.data;
    } catch {
        clearSession(store, req, res);
        return;
    }
    store.dispatch(setAuthDetails({ ...me }));

    const userSlug = me?.slug || me?.company;
    const currentUserProfile = userSlug
        ? store.dispatch(fetchCurrentUserProfile(userSlug))
        : Promise.resolve();

    if (!req) {
        await currentUserProfile;
        return;
    }

    if (me?.user?.deactivated === 1) {
        await currentUserProfile;
        clearSession(store, req, res);
        return;
    }

    store.dispatch(authSuccess(getCookie(AUTH_TOKEN_COOKIE, { req, res })));
    try {
        await Promise.all([
            currentUserProfile,
            store.dispatch(
                handleAuthorization(
                    params?.journalist || params?.company || null
                )
            ),
        ]);
    } catch {
        clearSession(store, req, res);
    }
}

function clearSession(store, req, res) {
    deleteCookie(AUTH_TOKEN_COOKIE, { ...options, req, res });
    deleteCookie(REFRESH_TOKEN_COOKIE, { ...options, req, res });
    store.dispatch(logout());
    store.dispatch(handleResetData());
}
